// extracted by mini-css-extract-plugin
module.exports = {"BooksOutlineButton":"BooksOutlineButton_BooksOutlineButton__3a7t2","isSmall":"BooksOutlineButton_isSmall__3W52P"};